module.exports = __webpack_public_path__ + "static/img/ex_logo_02.6afbcd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tube_ex/ex_logo_02.jpg
// module id = 3Jn1
// module chunks = 0